import { ref } from 'vue';
import { $api } from '@/services';

const error = ref(null);
const loading = ref(false);

export async function login(data: { email: string; password: string }) {
	error.value = null;
	try {
		const res = await $api.auth.login(data);
		if (!res) throw new Error('Lỗi khi đăng nhập');
		return res?.data;
	} catch (err) {
		error.value = err?.response?.data?.errors || err.message;
	} finally {
		loading.value = false;
	}
}

export function useLogin() {
	return { error, loading, login };
}
